import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/home/home_login.png'


const _withScopeId = n => (_pushScopeId("data-v-23abeba7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-menu" }
const _hoisted_3 = { class: "grid-content bg-purple menuicon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-h5",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = {
  key: 0,
  href: "/mine"
}
const _hoisted_6 = { class: "userInfo" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "menu-list"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<li data-v-23abeba7><a href=\"/\" data-v-23abeba7>首页</a></li><li data-v-23abeba7><a href=\"/message\" data-v-23abeba7>公告</a></li><li data-v-23abeba7><a href=\"/videoList\" data-v-23abeba7>公益视频</a></li><li data-v-23abeba7><a href=\"/publicWelfare\" data-v-23abeba7>公益活动</a></li><li data-v-23abeba7><a href=\"/story\" data-v-23abeba7>上进故事</a></li><li data-v-23abeba7><a href=\"/article?articleId=31\" data-v-23abeba7>关于我们</a></li>", 6)
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退出登录", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "menu-ipad-pc" }
const _hoisted_18 = { class: "menu-list" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<li data-v-23abeba7><img class=\"logo\" src=\"" + _imports_0 + "\" data-v-23abeba7></li><li data-v-23abeba7><a href=\"/\" data-v-23abeba7>首页</a></li><li data-v-23abeba7><a href=\"/message\" data-v-23abeba7>公告</a></li><li data-v-23abeba7><a href=\"/videoList\" data-v-23abeba7>公益视频</a></li><li data-v-23abeba7><a href=\"/publicWelfare\" data-v-23abeba7>公益活动</a></li><li data-v-23abeba7><a href=\"/story\" data-v-23abeba7>上进故事</a></li><li data-v-23abeba7><a href=\"/article?articleId=31\" data-v-23abeba7>关于我们</a></li>", 7)
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "user-name" }

import '@/assets/font/iconfont.css';
import { Toast } from 'vant';
import { ref, onMounted, unref } from 'vue';
import LoginToast from './loginToast.vue';
import { fullUrl } from '@/lib';
import { ClickOutside as vClickOutside } from 'element-plus';
interface EmitsType {
  (e: 'update:show'): void;
}

export default /*#__PURE__*/_defineComponent({
  emits: ["update:show"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:show'): void;
}), expose: any, slots: any, attrs: any }) {

const showMenu = ref(false);
const isLogin = ref(false);
const showLogin = ref(false);
const userImg = ref();
const userName = ref();

const buttonRef = ref();
const popoverRef = ref();
const onClickOutside = () => {
  unref(popoverRef).popperRef?.delayHide?.();
};



const onSelect = (action) => {
  if (action === '个人中心') {
    window.location.href = '/mine';
  } else {
    localStorage.clear();
    location.reload();
    Toast('退出成功');
  }
};
const text = () => {
  showLogin.value = true;
  console.log(showLogin, 'vue');
};

onMounted(() => {
  isLogin.value = !window.localStorage.getItem('authToken');
  userImg.value = window.localStorage.getItem('headImg') || '';
  userName.value = window.localStorage.getItem('realName') || '';
  userName.value =
    userName.value.length > 3
      ? userName.value.slice(0, 4) + '..'
      : userName.value;
});

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_row, { gutter: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("i", {
                    class: "iconfont icondaohang",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showMenu.value = !showMenu.value))
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 8,
              style: {"text-align":"center"}
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                (!isLogin.value)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("img", {
                          class: "head-img-h5",
                          src: _unref(fullUrl)(userImg.value),
                          alt: ""
                        }, null, 8, _hoisted_7)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "h5-btn",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (text()))
                    }, "登录"))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (showMenu.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
              _hoisted_9,
              (!isLogin.value)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (onSelect('退出登录')))
                  }, _hoisted_16))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("ul", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("li", null, [
            (!isLogin.value)
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "userInfo",
                  ref_key: "buttonRef",
                  ref: buttonRef
                }, [
                  _createElementVNode("img", {
                    class: "head-img",
                    src: _unref(fullUrl)(userImg.value),
                    alt: ""
                  }, null, 8, _hoisted_26),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(userName.value), 1)
                ])), [
                  [_unref(vClickOutside), onClickOutside]
                ])
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "pc-btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (text()))
                }, "登录/注册"))
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_popover, {
      ref_key: "popoverRef",
      ref: popoverRef,
      "virtual-ref": buttonRef.value,
      trigger: "hover",
      "virtual-triggering": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", {
          class: "user-title",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (onSelect('个人中心')))
        }, "个人中心"),
        _createElementVNode("p", {
          class: "user-title",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (onSelect('退出登录')))
        }, "退出登录")
      ]),
      _: 1
    }, 8, ["virtual-ref"]),
    _createVNode(LoginToast, {
      showLogin: showLogin.value,
      "onUpdate:confirm": _cache[6] || (_cache[6] = ($event: any) => (showLogin.value = false))
    }, null, 8, ["showLogin"])
  ]))
}
}

})